export const formatTimestampToDate = (timestamp: number | string) => {
  try {
    const date = new Date(timestamp);
    const formattedDate = date.toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    });
    return formattedDate;
  } catch (error) {
    console.error("Error:", error);
    return "Invalid timestamp";
  }
};

export const getTimestampForPeriod = (period: string) => {
  const now = new Date();

  switch (period) {
    case "today":
      now.setHours(0, 0, 0, 0);
      break;
    case "week":
      now.setDate(now.getDate() - 7);
      now.setHours(0, 0, 0, 0);
      break;
    case "month":
      now.setMonth(now.getMonth() - 1);
      now.setHours(0, 0, 0, 0);
      break;
    case "year":
      now.setFullYear(now.getFullYear() - 1);
      now.setHours(0, 0, 0, 0);
      break;
    default:
      throw new Error(
        'Invalid period. Supported values: "Today", "Week", "Month", "Year"'
      );
  }

  return now.getTime();
};

export const formatedDate = (time) => {
  const s = new Date(time);
  const date = `${s.getFullYear()}-${
    s.getMonth() < 9 ? `0${s.getMonth() + 1}` : s.getMonth() + 1
  }-${s.getDate() < 10 ? `0${s.getDate()}` : s.getDate()}`;
  return date;
};

export const formatedTime = (time) => {
  const s = new Date(time);
  return `${s.getHours() <= 9 ? `0${s.getHours()}` : s.getHours()}:${
    s.getMinutes() <= 9 ? `0${s.getMinutes()}` : s.getMinutes()
  }`;
};
export const GetHours = (time) => {
  const s = new Date(time);
  return s.getHours();
};

export const formatedFullDate = (time) => {
  const s = new Date(time);
  const date = `${s.getDate() < 10 ? `0${s.getDate()}` : s.getDate()}/${
    s.getMonth() < 9 ? `0${s.getMonth() + 1}` : s.getMonth() + 1
  }/${s.getFullYear()} at ${formatedTime(time)}`;

  return date;
};

export const findObjDifference = (obj1, obj2) => {
  const findNestedDifference = (nestedObj1, nestedObj2, prefix = "") => {
    let nestedDifference = [];
    for (let key in nestedObj1) {
      if (nestedObj2.hasOwnProperty(key)) {
        if (
          typeof nestedObj1[key] === "object" &&
          typeof nestedObj2[key] === "object"
        ) {
          nestedDifference = nestedDifference.concat(
            findNestedDifference(
              nestedObj1[key],
              nestedObj2[key],
              `${prefix}${key}.`
            )
          );
        } else {
          if (nestedObj1[key] !== nestedObj2[key]) {
            nestedDifference.push(`${prefix}${key}`);
          }
        }
      } else {
        nestedDifference.push(`${prefix}${key}`);
        break;
      }
    }
    if (
      ((nestedObj1 === null || nestedObj1?.length === 0) &&
        nestedObj2?.length > 0) ||
      nestedObj1?.length < nestedObj2?.length
    ) {
      nestedDifference.push(prefix);
    }
    return nestedDifference;
  };

  if (typeof obj1 === "object" && typeof obj2 === "object") {
    return findNestedDifference(obj1, obj2);
  } else {
    return [];
  }
};

export function getAbbreviatedDay(date: Date) {
  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const dayIndex = date.getDay();
  return daysOfWeek[dayIndex];
}

export const nextMonth = (time) => {
  const t = new Date(time);
  t.setMonth(t.getMonth() + 1);
  t.setHours(0, 0, 0, 0);
  return t;
};

export const actionColor = (actionType) => {
  switch (actionType) {
    case "create": {
      return { clr: "#2fa84f", bgClr: "#dcf7e3" };
    }
    case "update": {
      return { clr: "#367bf5", bgClr: "#e5efff" };
    }
    case "delete": {
      return { clr: "#ea3d2f", bgClr: "#fee4e2" };
    }

    case "status change": {
      return { clr: "white", bgClr: "#f3a72e" };
    }
    case "sensor unassignment": {
      return { clr: "white", bgClr: "gray" };
    }

    case "sensor assignment": {
      return { clr: "white", bgClr: "black" };
    }
    case "live": {
      return { clr: "white", bgClr: "purple" };
    }
    default: {
      return { clr: "black", bgClr: "white" };
    }
  }
};

export const arraysEqual = (arr1, arr2) => {
  if (arr1.length !== arr2.length) {
    return false;
  }
 return  arr1.every((item, index) => item === arr2[index]);
};
